import { useEffect } from 'react';
import { Card } from '../components/ui.jsx';
import { Phone } from '../components/icons.jsx';
import { CONTACT_DETAILS } from '../lib/siteContent.js';

export default function ThanksStep({ reference, phone = CONTACT_DETAILS.phone }) {
  useEffect(() => {
    /* Conversion signal for Google Ads. The tag itself is injected by GTM, so
       this only fires the event and stays silent when no tag is present —
       nothing here should ever break the confirmation page. */
    if (typeof window !== 'undefined') {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'lead_submitted', lead_reference: reference });
    }
  }, [reference]);

  return (
    <Card className="card--thanks">
      <h2 className="thanks__title">What happens next?</h2>

      <p className="thanks__body">
        One of our broadband switching team will call you from a {CONTACT_DETAILS.outboundPrefix} number and discuss
        the packages we have on offer.
      </p>

      <p className="thanks__prompt">
        <strong>Can’t wait to hear from us?</strong> Give us a call instead
      </p>

      <a className="button button--callback" href={`tel:${phone.replace(/\s/g, '')}`}>
        <span className="button__label">Call Us Now</span>
        <span className="button__icon" aria-hidden="true">
          <Phone size={16} />
        </span>
      </a>

      {/* The reference is not in the Figma, but it is the only thing a customer
          can quote back to us if they call before we call them. */}
      {reference && <span className="thanks__reference">Reference: {reference}</span>}
    </Card>
  );
}
